// extracted by mini-css-extract-plugin
export default {"zoomModal":"s2-z","image":"t2-z","button":"u2-z","isOverlayShown":"v2-z"};